// Built-in libraries

import { useParams } from 'react-router';
import type { IGetProjectServiceResData } from '@/api/Sherpa/Project/modules/ProjectCore/types';
// Custom Hooks
import { useProject } from '@/hooks/ReactQueryHooks/useProjectQuery';
import { useUsers } from '@/hooks/ReactQueryHooks/useUsersQuery';
// Assets & Miscellaneous
import type { User } from '@/types/User';
// Components
import DrawApprovers from './DrawApprovers';
import DrawInfo from './DrawInfo';

const DrawHeader = () => {
  const { projectId } = useParams<string>();
  const fetchProject = useProject({ projectId: parseInt(projectId!, 10) });
  const project: IGetProjectServiceResData | undefined = fetchProject?.data?.data;

  const fetchUsers = useUsers({
    params: { active: 'true' },
  });
  const users = fetchUsers.data?.data;

  const invoiceApprovers: User[] =
    users?.filter((user: User) => {
      return project?.drawSummary.invoiceApproverIds?.includes(user?.id);
    }) || [];
  const documentApprovers: User[] =
    users?.filter((user: User) => {
      return project?.drawSummary.documentApproverIds?.includes(user?.id);
    }) || [];

  return (
    <div className='mb-1 w-full inset-x-0 mx-auto -bottom-20 z-10 flex flex-col justify-between gap-4  px-6 bg-white rounded-md shadow-lg items-center'>
      {fetchProject.isLoading && <div className='w-full h-48 my-4 rounded animate-pulse bg-neutralColor-lighter'></div>}
      {project && (
        <>
          <DrawInfo name={project?.name} projectLead={project?.projectLead} drawSummary={project?.drawSummary} />
          <DrawApprovers invoiceApprovers={invoiceApprovers} documentApprovers={documentApprovers} />
        </>
      )}
    </div>
  );
};

export default DrawHeader;
